/**
 * Tour de France 2026 – Main entry point
 *
 * Built via theme's Gulp pipeline (manifest.json).
 */
(function ($) {
    'use strict';

    // =========================================================================
    // Ticket modal (jotform) — used on the On-Site template
    // =========================================================================
    var $overlay = $('.tdf26-modal-overlay');
    var $header  = $overlay.find('.tdf26-modal__header');
    var $title   = $overlay.find('.tdf26-modal__title');
    var $sub     = $overlay.find('.tdf26-modal__subtitle');
    var $body    = $overlay.find('.tdf26-modal__body');

    function openModal($trigger) {
        var title   = $trigger.data('modal-title');
        var sub     = $trigger.data('modal-subtitle');
        var color   = $trigger.data('modal-color');
        var jotform = $trigger.data('modal-jotform');

        $title.text(title);
        $sub.text(sub);

        $header.removeClass('tdf26-modal__header--yellow tdf26-modal__header--blue')
               .addClass('tdf26-modal__header--' + color);

        $body.html(
            '<iframe src="' + jotform + '" ' +
            'frameborder="0" scrolling="yes" ' +
            'style="width:100%;min-height:500px;border:none;" ' +
            'allowfullscreen></iframe>'
        );

        document.cookie = 'tdf26_redirect=' + encodeURIComponent(window.location.href) +
            ';path=/;max-age=3600;SameSite=Lax' +
            (window.location.protocol === 'https:' ? ';Secure' : '');

        $overlay.fadeIn(200);
        $('html').css('overflow', 'hidden');
    }

    function closeModal() {
        $overlay.fadeOut(200, function () {
            $body.empty();
        });
        $('html').css('overflow', '');
    }

    $(document).on('click', '[data-tdf-modal]', function (e) {
        e.preventDefault();
        openModal($(this));
    });

    $overlay.find('.tdf26-modal__close').on('click', closeModal);

    $overlay.on('click', function (e) {
        if ($(e.target).is($overlay)) {
            closeModal();
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape' && $overlay.is(':visible')) {
            closeModal();
        }
    });

    // =========================================================================
    // Bingo modal (Fan/Hero → WPForms → loading → final card)
    // =========================================================================
    var USERTYPE_FIELD = 23; // hidden WPForms field for Fan/Hero
    var $bingo = $('.tdf26-bingo-modal');

    if ($bingo.length && $('body').hasClass('tdf_2026')) {
        var bingo = new TDF2026();
        var chosenType = null;

        // Loading phrases cycle one-by-one over the 6s load (2s each); CSS crossfades
        // them via .is-active. Random order each open. PHP renders the phrases as
        // .tdf26-bingo-loading-text__item spans.
        var loadingTimer = null;

        var stopLoadingCycle = function () {
            if (loadingTimer) { clearInterval(loadingTimer); loadingTimer = null; }
        };

        var startLoadingCycle = function () {
            stopLoadingCycle();

            var $items = $bingo.find('.tdf26-bingo-step[data-step="loading"] .tdf26-bingo-loading-text__item');
            var n = $items.length;
            if (!n) { return; }

            var order = [];
            for (var i = 0; i < n; i++) { order.push(i); }
            order.sort(function () { return 0.5 - Math.random(); });   // random order each open

            var step = 0;
            var activate = function (k) {
                $items.removeClass('is-active');
                $items.eq(order[k % n]).addClass('is-active');
            };

            activate(0);                       // first phrase immediately
            loadingTimer = setInterval(function () {
                step += 1;
                activate(step);                // 2s per phrase; CSS does the fade
            }, 2000);
        };

        // Function expressions (not declarations) so this passes JSHint's
        // no-function-in-block rule used by the production build.
        var showStep = function (step) {
            if (step === 'loading') { startLoadingCycle(); }
            else { stopLoadingCycle(); }
            $bingo.find('.tdf26-bingo-step').hide();
            $bingo.find('.tdf26-bingo-step[data-step="' + step + '"]').show();
        };

        var openBingo = function () {
            chosenType = null;

            var state = (window.ys && window.ys.tdf2026 && window.ys.tdf2026.contestState) || 'open';
            if (state !== 'open') {
                // Show only the message matching the state (before/after).
                var $closed = $bingo.find('.tdf26-bingo-step[data-step="closed"]');
                $closed.find('[data-state]').hide();
                $closed.find('[data-state="' + state + '"]').show();
                showStep('closed');
            } else {
                showStep('side');
            }

            $bingo.css('display', 'flex').hide().fadeIn(200);
            $('html').css('overflow', 'hidden');
        };

        var closeBingo = function () {
            stopLoadingCycle();
            $bingo.fadeOut(200);
            $('html').css('overflow', '');

            // Drop the #bingo hash so refreshing after a manual close does NOT
            // re-open the modal ("Start over" sets the hash; closing must clear it).
            if (window.location.hash === '#bingo' && window.history && window.history.replaceState) {
                window.history.replaceState(null, '', window.location.pathname + window.location.search);
            }
        };

        // Reset the WPForms form to a clean state: clear entered values and any
        // validation messages/states left from a previous open. WPForms keeps
        // these in the DOM, so a reopened form would otherwise show the old data
        // and the old "field is required" errors even without re-submitting.
        var resetBingoForm = function () {
            var $form = $bingo.find('.wpforms-form');
            if (!$form.length) { return; }

            $form[0].reset();
            $form.find('label.wpforms-error, em.wpforms-error').remove();
            $form.find('.wpforms-error').removeClass('wpforms-error');
            $form.find('.wpforms-field-error, .wpforms-has-error')
                 .removeClass('wpforms-field-error wpforms-has-error');
            $form.find('[aria-invalid]').removeAttr('aria-invalid');
            $form.find('[aria-errormessage]').removeAttr('aria-errormessage');
        };

        // Open from any CTA.
        $(document).on('click', '[data-tdf-bingo]', function (e) {
            e.preventDefault();
            openBingo();
        });

        // Close interaction — ONLY the "×" button closes the modal. Clicking the
        // backdrop or pressing Escape must NOT close it (avoids losing entry data).
        $bingo.find('.tdf26-bingo-modal__close').on('click', closeBingo);

        // Step 1 → choose side, reset the form (clear old data/errors), stamp the
        // hidden field, advance to the form.
        $bingo.on('click', '.tdf26-bingo-side', function () {
            chosenType = $(this).data('usertype');
            resetBingoForm();
            $bingo.find('input[name="wpforms[fields][' + USERTYPE_FIELD + ']"]').val(chosenType);
            showStep('form');
        });

        // Step 2 → on WPForms AJAX success, run loading then final card.
        // The event bubbles up from the form; event.target is the form element.
        $(document).on('wpformsAjaxSubmitSuccess', function (event) {
            // Only react if our bingo form is the one inside the modal.
            if (!event.target || !$.contains($bingo[0], event.target)) { return; }

            showStep('loading');
            setTimeout(function () {
                bingo.renderCard(chosenType);
                showStep('final');
            }, 6000);
        });

        // Step 4 → actions.
        $bingo.on('click', '[data-bingo-action]', function (e) {
            e.preventDefault();
            var $action = $(this);
            switch ($action.data('bingo-action')) {
                case 'share':
                    // Mobile (< 768px) with file-share support → native share
                    // sheet with the card image. Otherwise show the desktop
                    // popover of URL share intents.
                    var canNativeShare = navigator.share && navigator.canShare &&
                        window.matchMedia('(max-width: 767px)').matches;

                    if (canNativeShare) {
                        bingo.shareCard();
                    } else {
                        $action.closest('.tdf26-bingo-share-wrap')
                               .find('.tdf26-bingo-share').toggle();
                    }
                    break;
                case 'download':   bingo.downloadCard(); break;
                case 'copy':
                    // Desktop popover only → copy the page URL and pulse.
                    bingo.copyLink();
                    $action.addClass('is-copied');
                    setTimeout(function () { $action.removeClass('is-copied'); }, 600);
                    console.log( 'copied link' );
                    break;
                case 'start-over':
                    window.location.hash = 'bingo';
                    window.location.reload();
                    break;
            }
        });

        // Share menu items. Instagram has no web intent → use native share
        // (the card image); the rest open their share URLs.
        $bingo.on('click', '[data-bingo-share]', function (e) {
            e.preventDefault();
            var net = $(this).data('bingo-share');
            if (net === 'instagram') { bingo.shareCard(); }
            else { bingo.shareTo(net); }
        });

        // Click a bingo cell → toggle its description bubble (center logo excluded).
        $bingo.on('click', '.tdf26-bingo-cell:not(.tdf26-bingo-cell--logo)', function () {
            bingo.toggleDescription(this);
        });

        // Close the share popover when clicking outside it.
        $(document).on('click', function (e) {
            if (!$(e.target).closest('.tdf26-bingo-share-wrap').length) {
                $bingo.find('.tdf26-bingo-share').hide();
            }
        });

        // Re-open after "start over" reload.
        if (window.location.hash === '#bingo') {
            openBingo();
        }
    }

    // =========================================================================
    // Rounds prize switcher (UI only — does not change the current/active week)
    // =========================================================================
    var $prizeList = $('.tdf26-prize-list');

    function animatePrizeRound($round) {
        if (!$round || !$round.length) { return; }
        var $items = $round.find('ul li');
        $items.removeClass('is-visible');
        void $round[0].offsetWidth; // force reflow so the transition replays
        $items.each(function (i) {
            var el = this;
            setTimeout(function () { el.classList.add('is-visible'); }, i * 100);
        });
    }

    if ($prizeList.length) {
        $prizeList.addClass('tdf26-anim');
        // Animate the initially-active round on load.
        animatePrizeRound($prizeList.find('.tdf26-prize-list__round.active'));
    }

    $(document).on('click', '.rounds li[data-round] a', function (e) {
        e.preventDefault();
        var round = $(this).closest('li').data('round');

        $('.rounds li[data-round]').removeClass('active');
        $(this).closest('li').addClass('active');

        $('.tdf26-prize-list__round').removeClass('active');
        var $newRound = $('.tdf26-prize-list__round[data-round="' + round + '"]').addClass('active');

        animatePrizeRound($newRound);
    });

    // =========================================================================
    // Instagram video player
    // =========================================================================
    $('.tdf26-live__video[data-video-src]').each(function () {
        var $wrap  = $(this);
        var $btn   = $wrap.find('.tdf26-live__play');
        var $thumb = $wrap.find('img');
        var src    = $wrap.data('video-src');

        var video = null;

        $btn.on('click', function () {
            if (!video) {
                video = document.createElement('video');
                video.src = src;
                video.poster = $thumb.attr('src') || '';
                video.playsInline = true;
                video.controls = false;
                video.preload = 'auto';
                video.style.cssText = 'width:100%;height:100%;object-fit:cover;border-radius:inherit;';

                $thumb.remove();
                $wrap.append(video);

                $(video).on('ended', function () {
                    $btn.css('opacity', '1');
                });
            }

            if (video.paused) {
                video.play();
                $btn.css('opacity', '0');
            } else {
                video.pause();
                $btn.css('opacity', '1');
            }
        });
    });

}).bind(window)(jQuery);
